// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"BackgroundPicker_colorPicker__2W9xo","sketchPicker":"BackgroundPicker_sketchPicker__17yxA"};